export default __webpack_public_path__ + "static/media/map_point.ce31e36a.svg";